module.exports = __webpack_public_path__ + "static/media/DeleteEventIcon.99aff18a.svg";